import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleTag", "items", "layoutType", "backgroundImage", "description", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { Typography } from '@snack-uikit/typography';
import { BenefitItem } from '../../helperComponents';
import { SectionBasic } from '../SectionBasic';
import styles from "./styles.module.css";
import { getTitleTypographyProps } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionBenefitsBanner(_ref) {
  var title = _ref.title,
    _ref$titleTag = _ref.titleTag,
    titleTag = _ref$titleTag === void 0 ? 'h3' : _ref$titleTag,
    items = _ref.items,
    layoutType = _ref.layoutType,
    backgroundImage = _ref.backgroundImage,
    description = _ref.description,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    layoutType: layoutType,
    className: className
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.bannerWrapper,
      "data-layout-type": layoutType,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.banner,
        "data-layout-type": layoutType,
        children: [/*#__PURE__*/_jsx("img", {
          className: styles.illustration,
          src: backgroundImage,
          alt: "benefits-illustration",
          "data-layout-type": layoutType
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.contentWrapper,
          children: [title && /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
            family: "light",
            tag: titleTag
          }, getTitleTypographyProps(layoutType)), {}, {
            children: /*#__PURE__*/_jsx(RichText, {
              richText: title
            })
          })), /*#__PURE__*/_jsx("div", {
            className: styles.benefitItems,
            "data-layout-type": layoutType,
            children: items.map(function (item) {
              return /*#__PURE__*/_jsx(BenefitItem, _objectSpread(_objectSpread({}, item), {}, {
                layoutType: layoutType
              }), item.description);
            })
          })]
        })]
      }), description && /*#__PURE__*/_jsx("div", {
        className: styles.description,
        "data-attribute": "no_search_index",
        children: /*#__PURE__*/_jsx(Typography, {
          family: "sans",
          purpose: "body",
          size: "m",
          tag: "div",
          children: Array.isArray(description) ? description.map(function (item) {
            return /*#__PURE__*/_jsx(RichText, {
              richText: item
            }, item);
          }) : /*#__PURE__*/_jsx(RichText, {
            richText: description
          })
        })
      })]
    })
  }));
}